<!--
 * @Description: 调研问卷/可配置/数字问卷详情
 * @Date: 2025-04-11 18:44:27
-->
<template>
  <div class="question-detail">
    <BaseDescriptions
      v-for="(topic, index) in questionInfo"
      :key="index"
      :title="getTitle(topic, index)"
      :column="1"
      size="large"
      direction="vertical"
    >
      <!-- 目标题 -->
      <template v-if="topic.topicType === -1">
        <BaseDescriptionsItem>
          <div
            style="
              display: flex;
              align-items: center;
              border-bottom: 1px solid #e8e8e8;
              padding: 5px;
            "
            v-for="answer in topic.values"
            :key="answer.label"
          >
            <div style="white-space: nowrap; width: 30%">
              {{ answer.label }}：
            </div>
            <div style="width: 70%">{{ answer.values }}</div>
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 时间段题 -->
      <template v-if="topic.topicType === 31">
        <BaseDescriptionsItem>
          <div>
            {{ formatter.date(topic.values.startAt) }}-{{
              formatter.date(topic.values.endAt)
            }}
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 时刻题 -->
      <template v-if="topic.topicType === 29">
        <BaseDescriptionsItem>
          <div>{{ formatter.date(topic.values.startAt) }}</div>
        </BaseDescriptionsItem>
      </template>
      <!-- 定位题 -->
      <template v-if="topic.topicType === -3">
        <BaseDescriptionsItem>
          <img @click="onChangeShowIndex(topic.values)" :src="topic.values" />
          <BaseButton
            style="margin-left: 5px"
            @click="onDiffMap"
            type="primary"
          >
            对比地图
          </BaseButton>
          <BaseButton
            v-if="isShowMapHandleBtn"
            @click="onMapRefresh()"
            type="success"
          >
            更新地图
          </BaseButton>
        </BaseDescriptionsItem>
      </template>
      <!-- 单选题/多选/投票题/时间题/月度题/单项填空题/姓名填空题/下拉框/多级下拉框/受访者来源/描述提/段落说明 -->
      <template
        v-else-if="
          [1, 2, 3, 14, 15, 19, 4, 22, 23, 24, 25, 30, 17, 26].includes(
            topic.topicType
          )
        "
      >
        <BaseDescriptionsItem>
          {{ filterAnswers(topic) }}
        </BaseDescriptionsItem>
      </template>
      <!-- 多项填空题 -->
      <template v-else-if="[5].includes(topic.topicType)">
        <BaseDescriptionsItem
          :key="option + index"
          v-for="(option, index) in topic.optionJson"
        >
          <div style="margin-bottom: 5px">{{ option }}</div>
          <div>
            {{ (topic.values && topic.values[index]) || '无' }}
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 打分题 -->
      <template v-else-if="[6].includes(topic.topicType)">
        <BaseDescriptionsItem>
          <div style="display: flex; align-items: center">
            <div :key="index" v-for="index in [1, 2, 3, 4, 5]">
              <BaseSvg
                v-if="index <= +topic.values"
                style="font-size: 18px"
                iconClass="wujiaoxing_cheng"
              ></BaseSvg>
              <BaseSvg
                v-else
                style="font-size: 18px"
                iconClass="wujiaoxing_hui"
              ></BaseSvg>
            </div>
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 上传pdf/上传word/上传excel/上传ppt -->
      <template v-else-if="[8, 9, 10, 11, 12].includes(topic.topicType)">
        <BaseDescriptionsItem v-if="!topic.values">无</BaseDescriptionsItem>
        <BaseDescriptionsItem
          v-else
          :key="value + index"
          v-for="(value, index) in topic.values"
        >
          <div>
            <BaseButton
              :disabled="!value.url"
              @click="onViewer(value.url)"
              type="text"
            >
              {{ value.name || value.url || '无' }}
            </BaseButton>
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 图片题 -->
      <template v-else-if="[13].includes(topic.topicType)">
        <BaseDescriptionsItem v-if="!topic.values">无</BaseDescriptionsItem>
        <BaseDescriptionsItem v-else>
          <div
            :key="value + index"
            v-for="(value, index) in topic.values"
            style="display: inline-block"
          >
            <img
              style="margin: 5px"
              @click="onChangeShowIndex(value.url)"
              :src="value.url"
            />
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 视频题 -->
      <template v-else-if="[32].includes(topic.topicType)">
        <BaseDescriptionsItem v-if="!topic.values">无</BaseDescriptionsItem>
        <BaseDescriptionsItem v-else>
          <div
            :key="value + index"
            v-for="(value, index) in topic.values"
            style="display: inline-block"
          >
            <video
              style="margin: 5px; width: 200px"
              :src="value.url"
              :poster="value.cover || undefined"
              controls
            ></video>
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 签名题 -->
      <template v-else-if="[20].includes(topic.topicType)">
        <BaseDescriptionsItem>
          <div v-if="topic.values">
            <img @click="onChangeShowIndex(topic.values)" :src="topic.values" />
          </div>
          <div v-else>无</div>
        </BaseDescriptionsItem>
      </template>
      <!-- 定位题 -->
      <template v-else-if="[16].includes(topic.topicType)">
        <BaseDescriptionsItem>
          <div>
            <div v-if="topic.values.addressPicUrl">
              <img
                @click="onChangeShowIndex(topic.values.addressPicUrl)"
                :src="topic.values.addressPicUrl"
              />
              <BaseButton
                v-if="isShowMapHandleBtn"
                style="margin-left: 5px"
                @click="onDiffMap"
                type="primary"
              >
                对比地图
              </BaseButton>
              <BaseButton
                v-if="isShowMapHandleBtn"
                @click="onMapRefresh()"
                type="success"
              >
                更新地图
              </BaseButton>
            </div>

            <div v-else>无</div>
          </div>
        </BaseDescriptionsItem>
      </template>
      <!-- 描述题 -->
      <template v-else-if="[18].includes(topic.topicType)">
        <BaseDescriptionsItem></BaseDescriptionsItem>
      </template>
      <BaseDescriptionsItem
        v-if="topic.remark"
        :label="`备注：${topic.remark}`"
      ></BaseDescriptionsItem>
    </BaseDescriptions>
  </div>
</template>
<script lang="tsx" setup>
import {
  BaseButton,
  BaseDescriptions,
  BaseDescriptionsItem
} from 'xrk-components';
import { QUESTION_TYPE } from '../../constants';
import { FILE_VIEW_URL } from '@/config';
import { BaseSvg } from '@/components/base/base-svg/index';

import { formatter } from '@/utils';

withDefaults(
  defineProps<{
    questionInfo: any;
    isShowMapHandleBtn?: boolean; // 是否显示地图操作按钮
  }>(),
  {
    isShowMapHandleBtn: true,
    questionInfo: () => ({})
  }
);
const emits = defineEmits(['changeImgUrl', 'mapRefresh', 'diffMap']);

const onChangeShowIndex = url => {
  emits('changeImgUrl', url);
};
const getTitle = (topic, index) => {
  // '1.此题为选择等级医院医生（点击编辑题干）[目标题](必填):';
  return `${index + 1}.${topic.label}[${QUESTION_TYPE[topic.topicType].label}]${
    topic.isMustFill ? '(必填)' : ''
  }`;
};

//文件预览
const onViewer = url => {
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};

const onMapRefresh = () => {
  emits('mapRefresh');
};

const onDiffMap = () => {
  emits('diffMap');
};

const filterAnswers = ({ topicType, values }) => {
  if (!values || values.length === 0) {
    return '无';
  }
  if ([30].includes(topicType)) {
    return values.fullName || '无';
  }
  if ([1, 3, 19, 4, 17, 22].includes(topicType)) {
    return values || '无';
  }
  if ([14].includes(topicType)) {
    return formatter.date(values);
  }
  if ([15].includes(topicType)) {
    return formatter.date(values, 'YYYY-MM');
  }
  if ([2, 23, 26].includes(topicType)) {
    return values.join(',');
  }
  if ([24].includes(topicType)) {
    if (values.length === 0) {
      return '无';
    }
    return flattenArray(values)
      .map(item => item.label || '无')
      .join('/');
  }
  if (topicType === 25) {
    return values.map(item => item || '无').join('/');
  }
};
function flattenArray(arr) {
  return arr.flatMap(item => [item, ...flattenArray(item.children || [])]);
}
</script>
<style lang="scss" scoped>
.question-detail {
  img {
    width: 100px;
    cursor: pointer;
  }
  .xrk-descriptions__cell {
    margin-bottom: 10px;
  }
}
</style>
